import React, { useState, useEffect, useContext } from 'react';
import logo from '../../assets/logo-home.png';
import './styles.css';
import '../../App.css';
import Api from '../../services/Api'
import UserContext from '../../contexts/UserContext';
import { useTranslation } from 'react-i18next';

function Login({ history }) {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [msgErro, setMsgErro] = useState(false);
  const {user, setUser} = useContext(UserContext);

  useEffect(() => {
    const user_id = localStorage.getItem('user');
    if(user_id) {
      validaLogin({preventDefault: ()=> {}}, user_id);
    }
  }, []);

  async function validaLogin(event, user_id) {
    event.preventDefault();
    const response = await Api.login(email, senha, user_id);
    if(response && response?.token){
      localStorage.setItem('user', response?.user._id);
      localStorage.setItem('token', response?.token);
      history.push('/dashboard');
      setUser([response?.user]);
    } else {
      setMsgErro(true);  
      setUser([]);  
    }
  }
  return (
    <div className="container">
      <div className="v-center" style={{height: '100vh' }}>
      <div className="login">
        {/*<img id="logo" src={logo}/>*/}
        <h1 id="logo" >e-iris.</h1>  
        <div className="content">
          <div className="text-center">
            <h1>{t('auth.login')}</h1>
            <p>{t('auth.loginSubtitle')}</p>
          </div> 
          <br/>
          <form onSubmit={validaLogin}>
            <div className="form-group">
              <label className="labelInput">{t('auth.emailLabel')}</label>
              <input 
                type="email" 
                className="form-control" 
                name="email" 
                id="email" 
                placeholder={t('auth.emailPlaceholder')}
                value={email}
                onChange={event => setEmail(event.target.value)}/>
            </div>            
            <div className="form-group">
              <label className="labelInput">{t('auth.passwordLabel')}</label>
              <input 
                type="password"  
                className="form-control" 
                name="senha" id="senha" 
                placeholder={t('auth.passwordPlaceholder')}
                value={senha}                
                onChange={event => setSenha(event.target.value)}/>
            </div>
            <p className={`col-12 alert alert-danger ${msgErro === false ? 'hidden' : ''}`} onClick={() => setMsgErro(false)}>{t('auth.loginError')}</p>
            <button type="submit" className="btn btn-default col-12">{t('auth.loginButton')}</button>
          </form>
        </div>
      </div>
      </div>
    </div>
  );
}

export default Login;
